
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Rodape extends Vue {
    loading1 = false;
    loading2 = false;
    loading3 = false;
    selection = 1;

    reserve1() {
      this.loading1 = true;
      setTimeout(() => (this.loading1 = false), 2000);
    }

    reserve2() {
      this.loading2 = true;
      setTimeout(() => (this.loading2 = false), 2000);
    }

    reserve3() {
      this.loading3 = true;
      setTimeout(() => (this.loading3 = false), 2000);
    }
}
